import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var TickSystemIcon = function TickSystemIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M1.282 11.836a.75.75 0 00-1.117 1L7.841 21.4a.75.75 0 001.133-.018L23.609 3.94a.75.75 0 10-1.149-.964L8.38 19.756l-7.098-7.92z"
  }));
};

TickSystemIcon.displayName = "TickSystemIcon";
TickSystemIcon.defaultProps = {
  size: 24
};
TickSystemIcon.displayName = "TickSystemIcon";
TickSystemIcon.iconName = "Tick";
export default TickSystemIcon;